
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import { useNotification } from "../Notification/notification";
import "./SignUp.css";

export default function SignUp() {
  const navigate = useNavigate();
  const { notify } = useNotification();

  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    address: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const togglePassword = () => setShowPassword(!showPassword);

 
  const sendOtp = async () => {
    if (!formData.email) {
      return notify("Email is required", "error");
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();

      if (!res.ok) {
        return notify(data.message || "Failed to send OTP", "error");
      }

      notify("OTP sent to email", "success");
      setStep(2);
    } catch (error) {
      notify("Server error", "error");
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, password, phone, address } = formData;

    if (!name || !email || !password || !phone || !address || !otp) {
      return notify("Please fill all fields", "error");
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          otp,
          password,
          phone,
          address,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        return notify(data.message || "OTP verification failed", "error");
      }

      notify("Account created successfully!", "success");
      navigate("/signin");
    } catch (error) {
      notify("Server error", "error");
    }
  };

  useEffect(() => {
    document.body.classList.add("auth-page");
    return () => document.body.classList.remove("auth-page");
  }, []);

  return (
    <>
    <div className="auth-wrapper">

      {/* LEFT */}
      <div className="auth-left">
        <img src="/Logo/updated-logo.png" alt="logo" />
        <h1>Sulav Sewa</h1>
        <p>Smart & Reliable Home Services</p>
      </div>

      {/* RIGHT */}
      <div className="auth-right">
        <div className="auth-card">
          <h3>Create Account</h3>

          <form onSubmit={handleSubmit}>

            {/* NAME */}
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              onChange={handleChange}
            />

            {/* EMAIL */}
            <input
              type="email"
              name="email"
              placeholder="Email address"
              onChange={handleChange}
            />

            {/* PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                onChange={handleChange}
              />
              <span onClick={togglePassword}>
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>

            {/* PHONE */}
            <input
              type="tel"
              name="phone"
              placeholder="Phone number"
              onChange={handleChange}
            />

            {/* ADDRESS */}
            <input
              type="text"
              name="address"
              placeholder="Address"
              onChange={handleChange}
            />

            {/* OTP INPUT (ONLY AFTER STEP 2) */}
            {step === 2 && (
              <input
                type="text"
                placeholder="Enter OTP"
                onChange={(e) => setOtp(e.target.value)}
              />
            )}

            {/* BUTTONS */}
            {step === 1 ? (
              <button
                type="button"
                className="btn-primary"
                onClick={sendOtp}
              >
                Send OTP
              </button>
            ) : (
              <button className="btn-primary">
                Verify & Create Account
              </button>
            )}
          </form>

          <p className="switch">
            Already have an account? <Link to="/signin">Sign In</Link>
          </p>
        </div>
      </div>

    </div>
       <button className="back-button-bottom" onClick={() => navigate(-1)}>
    ← Back
  </button>
  </>
  );
}